import { useEffect } from 'react';
import I18n from 'I18n';
import { URLServiceComponent } from '../OAuthIntegrations/URLServiceComponent';
import { useUpdateGoogleSearchConsoleAccount } from './googleSearchConsoleApi';
import { jsx as _jsx } from "react/jsx-runtime";
export const GoogleSearchConsoleServiceComponent = ({
  metadata,
  onAuthCancelled,
  onAuthFailed,
  onAuthSucceeded,
  reconnectStarted,
  timeout,
  url
}) => {
  const {
    updateAccount,
    error: updatingError
  } = useUpdateGoogleSearchConsoleAccount();
  useEffect(() => {
    if (updatingError) {
      onAuthFailed === null || onAuthFailed === void 0 || onAuthFailed({
        error: updatingError,
        errorMessage: I18n.text('reconnect.errors.updateAccountFailed')
      });
    }
  }, [updatingError, onAuthFailed]);
  const handleAuthSucceeded = authedEmail => {
    void updateAccount(authedEmail).then(() => {
      if (!updatingError) {
        onAuthSucceeded === null || onAuthSucceeded === void 0 || onAuthSucceeded(authedEmail);
      }
    });
  };
  return /*#__PURE__*/_jsx(URLServiceComponent, {
    metadata: metadata,
    onAuthSucceeded: handleAuthSucceeded,
    onAuthCancelled: onAuthCancelled,
    onAuthFailed: onAuthFailed,
    reconnectStarted: reconnectStarted,
    timeout: timeout,
    url: url
  });
};